import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface IContainerType extends IBaseEntity {
    id?: number;
    type?: string;
}

export class ContainerType extends BaseEntity implements IContainerType {
    public id?: number;
    public type?: string;

    constructor(containerType?: any) {
        super();
        if (containerType) {
            this.id = containerType.id;
            this.type = containerType.type;
        }
    }

    clone(): ContainerType {
        return new ContainerType(this);
    }
}
